import React, { useEffect, useState } from 'react';
import {
	Button,
	Col,
	Loader,
	Row,
	Slider,
	Toast,
	Tooltip
} from '@kaleyra/emmy';
import { useTranslation } from 'react-i18next';
import Styles from './index.module.scss';
import { limitStringLength, removeBackSlash } from '../../../../../utils';

import CopyImg from '../../../../../assets/CopySVG.svg';

export type MapStatePropsType = {
	params: any;
};

export type DispatchPropsType = {
	onClose: () => void;
	getApiKeyDetails: (data: any, res: any) => void;
};

const ViewApiKeys: React.FC<MapStatePropsType & DispatchPropsType> = ({
	onClose,
	params,
	getApiKeyDetails
}) => {
	const { t } = useTranslation();
	const [data, setData] = useState<any>([]);
	const [whiteListedIP, setWhiteListedIp] = useState('')
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (params) {
			getApiKeyDetails({
				api_key_id: params?.id
			}, (resp: any, success: boolean) => {
				if (success) {
					setIsLoading(false);
					setData(resp?.data[0]);
					setWhiteListedIp(removeBackSlash(resp?.data[0]?.ip_config?.ip_addresses || resp?.data[0]?.whitelisted_ips));
				}
			})
		}
	}, [params]);

	const tooltipTitle = whiteListedIP.split(',').slice(5);
	const whitelistedIps = whiteListedIP.split(',').slice(0, 5);

	const generateSuccessContent = () => {
		return (
			<>
				<div className={Styles.apiKeyDetails}>{t("KLR02693")}</div>
				<Row className={Styles.h}>
					<Col size={4}>
						<div className={Styles.rowKey}>{t("KLR02694")}</div>

					</Col>
					<Col size={8} gutter>
						<div className={Styles.rowValue}>{data?.api_name || '-'}</div>
					</Col>
				</Row>
				<Row className={Styles.h}>
					<Col size={4}>
						<div className={Styles.rowKey}>{t('apiDomain')}</div>

					</Col>
					<Col size={8} gutter>
						<div className={Styles.rowValue}>{data?.host || '-'}</div>
					</Col>
				</Row >
				<Row className={Styles.h}>
					<Col size={4}>
						<div className={Styles.rowKey}>{t('apiSid')}</div>

					</Col>
					<Col size={8} gutter>
						<div className={Styles.rowValue}>{data?.sid || '-'}</div>
					</Col>
				</Row>
				<Row className={Styles.h}>
					<Col size={4}>
						<div className={Styles.rowKey}>{t('apiKey')}</div>

					</Col>
					<Col size={8} gutter>
						<Row>
							<Col size={11}>
								<div className={Styles.apiKeyP}>
									{data?.api_key_full}
								</div>
							</Col>
							<Col size={1}>
								<img
									src={CopyImg}
									className={Styles.copyImgEdit}
									onClick={() => {
										navigator.clipboard.writeText(
											data?.api_key_full
										);
										Toast(
											t('mainCopiedToClipboard'),
											'success',
											() => null
										);
									}}
									alt="copy"
								/>
							</Col>
						</Row>
					</Col>
				</Row>
				{
					data?.ip_config?.name &&
					<Row className={Styles.h}>
						<Col size={4}>
							<div className={Styles.rowKey}>{t("KLR02713")}</div>

						</Col>
						<Col size={8} gutter>
							<div className={Styles.rowValue}>{limitStringLength(data?.ip_config?.name || '-', 32)}</div>
						</Col>
					</Row>

				}
				{
					whiteListedIP &&
					<Row className={Styles.h}>
						<Col size={4}>
							<div className={Styles.rowKey}>{t("KLR02695")}</div>

						</Col>
						<Col size={8} gutter>
							<div className={Styles.rowValue}>
								<div style={{ wordBreak: 'break-word' }}>
									{whitelistedIps.join(' , ')}
									{
										(tooltipTitle.length > 0) &&
										<Tooltip
											title={tooltipTitle.join(" , ")}
											placement="bottomRight"
											color={'#212B36'}
											arrowPointAtCenter
											overlayInnerStyle={{ borderRadius: "4px" ,maxHeight:150,overflow:'auto'}}
										>
											<span className={Styles.ipAddress}>
												+{tooltipTitle.length}
											</span>
										</Tooltip>
									}
								</div>
							</div>
						</Col>
					</Row>
				}
				<Button
					type="secondary"
					onClick={() =>
						window.open('https://developers.kaleyra.io', '__blank')
					}
					className={Styles.documentEdit}
					small
				>
					<span>{t('readDocument')}</span>
				</Button>
			</>
		)
	}
	return (
		<Slider
			containerId="root-modal"
			onClose={onClose}
			visibility={true}
			title={t("KLR02696")}
		>
			{isLoading ? <Loader /> : generateSuccessContent()}
		</Slider>
	);
};

export default ViewApiKeys;
